export default __webpack_public_path__ + "static/media/first-left-img.7dc561c3.png";